import * as React from 'react';
import { observer } from 'mobx-react';

// Props
interface ICustomElementProps {
    component: string;
    properties?: object;
}

// Component
@observer
export class CustomElement extends React.Component<ICustomElementProps, {}> {
    static get defaultProps(): ICustomElementProps {
        return {
            component: 'div',
            properties: null
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        return React.createElement(this.props.component, this.props.properties, this.props.children);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/element/CustomElement.tsx